import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { usePublisherCreate } from '@/module/Publisher/model/PublisherQuery';
import { PublisherSchema, defaultPublisherValues, publisherSchema } from '@/module/Publisher/model/PublisherSchema';

import { useAppNotification } from '@feature/utils';

import { PublisherForm } from './PublisherForm';

export function PublisherCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = usePublisherCreate();

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: PublisherSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newPublisher => {
        notification.success();
        navigate({ to: '/publisher/$publisherId', params: { publisherId: String(newPublisher.id) } });
      },
    });
  };

  return (
    <PublisherForm
      title={t('publishers.form.title.create')}
      schema={publisherSchema}
      defaultValues={defaultPublisherValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
